export default "__VITE_ASSET___ku5PprP__"